import { StyledIconMonitor } from './IconMonitor.styled';

const IconMonitor = () => {
  return <StyledIconMonitor />;
};

export default IconMonitor;
